<template>
  <div>
    <user-add user-title="售后服务" user-add-url="/user/service/add" />
    <el-table :data="Cdata"  class="item-table" height="80vh">
      <el-table-column  width="100">
        <template slot-scope="scope" >
          <img class="item-image" :src="'http://'+Cdata[scope.$index].photoUrl" alt="">
        </template>
      </el-table-column>
      <el-table-column label="id" width="60" prop="id"></el-table-column>
      <el-table-column label="名称" prop="name" width="80"></el-table-column>
      <el-table-column label="图片地址" prop="photoUrl"></el-table-column>
      <el-table-column label="文件描述" prop="description" width="300"></el-table-column>

      <el-table-column label="创建时间" prop="createTime" width="140"></el-table-column>
      <el-table-column label="更新时间" prop="updateTime" width="140"></el-table-column>
      <el-table-column label="操作" width="160">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleLook(Cdata[scope.$index].id)">查看</el-button>
          <el-button type="text" size="small" @click="handleChange(Cdata[scope.$index].id)">修改</el-button>
          <el-button type="text" size="small" @click="handleDelete(Cdata[scope.$index].id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import UserAdd from "@/views/User/Common/UserAdd";
export default {
name: "ServiceBase",
  components: {UserAdd},
  data(){
    return{
      Cdata:null,//当前表格展示数据
    }
  },
  created() {
    this.GetData()
  },
  methods:{
    GetData(){
      this.$axios.get('/api/after/getAll').then(res=>{
        this.Cdata=res.data.data
      })
    },
    handleCurrentChange(index){
      this.PostData.pageNumber=index;
      this.GetData(this.PostData)
    },
    handleLook(id){
      this.$router.push('/user/service/look'+id)
    },
    handleChange(id){
      this.$router.push('/user/service/change'+id)
    },
    Delete(id){
      this.$axios.delete('/api/after/deleteById',{params:{
          id:id
        }}).then(res=>{
        this.GetData(this.PostData)
      })
    },
    handleDelete(id){
      this.$confirm('确定删除该条信息', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.Delete(id)
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
  }
}
</script>

<style scoped>
.item-image{
  height: 40px;
  width: auto;
  object-fit: cover;
}
</style>